import core from '@joey-wallet/wc-client/core';

const chains = core.constants.chains;

export const joeyConfig = {
  // Use your Reown / WalletConnect Project ID here
  projectId: process.env.REACT_APP_REOWN_PROJECT_ID || 'YOUR_WALLETCONNECT_PROJECT_ID',
  
  namespaces: chains.xrplNamespace,
  defaultChain: chains.xrpl.mainnet.id, // Or testnet depending on your environment
  
  walletDetails: [{
      name: 'Joey Wallet',
      projectId: 'd9f5432e932c6fad8e19a0cea9d4a3372a84aed16e98a52e6655dd2821a63404',
      deeplinkFormat: 'joey://settings/wc?uri=',
  }],
  
  verbose: true, // Helpful for debugging
  storage: {
    enabled: true,
    custom: null,
  },
  
  metadata: {
    name: 'Sonar Muse',
    description: 'A Web3 Music Store and Streaming Platform on the XRPL',
    url: window.location.origin,
    icons: ['https://sonarmuse.org/favicon.ico'],
    redirect: window.location.origin,
  },
};